import { Fragment, useState, useEffect, useRef } from "react";
import withStyles from "react-jss";
import axios from "axios";
import Parser from "html-react-parser";
import { RangeSlider } from "../index";

import useStateCallback from "../../utils/useStateCallback.ts";
import { tsvJSON } from "../../utils/helper";

const styles = {
  main: {
    position: "relative",
    width: "100%",
    display: "flex",
    maxWidth: "1140px",
    margin: "0 auto",
    padding: "15px 0",
    color: "#ffffff",
    boxSizing: "border-box",
    "@media only screen and (max-width: 840px)": {
      flexDirection: "column",
    },
  },
  right: {
    boxSizing: "border-box",
    position: "relative",
    width: "55%",
    margin: 0,
    // background: "grey",
    "@media only screen and (max-width: 840px)": {
      position: "sticky",
      bottom: 0,
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
      height: "100vh",
    },
  },
  left: {
    boxSizing: "border-box",
    width: "45%",
    padding: "0 16px",
    zIndex: 2,
    "@media only screen and (max-width: 840px)": {
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
    },
    "& p": {
      fontFamily: "BreveText",
      fontSize: "19px",
    },
  },
  text: {
    width: "100%",
    maxWidth: "460px",
    boxSizing: "border-box",
    fontFamily: "BreveText",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "19px",
    margin: "80vh auto",
    padding: "16px 24px",
    background: "#ffffff",
    borderRadius: "4px",
    color: "#000000",
    "@media only screen and (max-width: 840px)": {
      padding: "16px",
      margin: "100vh auto",
    },
  },
  rightBox: {
    top: 0,
    width: "100%",
    height: "100vh",
    display: "flex",
    position: "sticky",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    paddingBottom: "50px",
    paddingTop: "20px",
    "@media (max-width: 780px)": {
      justifyContent: "start",
    },
    "& h1": {
      borderBottom: "1px solid #ffffff",
      lineHeight: "60px",

      fontFamily: "WiredMono",
      fontStyle: "normal",
      fontWeight: "700",
      fontSize: "18px",
    },
    "& p": {
      fontFamily: "WiredMono",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "14px",
      display: "flex",
      justifyContent: "space-between",
      textTransform: "uppercase",
      flexDirection: "column",
      margin: 0,
    },
  },
  flexBox: {
    display: "flex",
    justifyContent: "space-around",
    margin: "15px 0px",
    "@media (max-width: 780px)": {
      margin: "10px 0px",
    },
  },
  ParaScore: {
    display: "flex",
    width: "80%",
    justifyContent: "space-between",
    borderTop: "1px solid #fff",
    lineHeight: "60px",
    display: "flex",
    flexDirection: "column",
  },
  slider: {
    display: "flex",
    width: "80%",
    justifyContent: "space-between",

    lineHeight: "60px",
    display: "flex",
    flexDirection: "column",
    "& p": {
      margin: "15px 0",
      textAlign: "center",
    },
  },

  ParaScoreSpan: {
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "18px !important",
    display: "flex",
    flexDirection: "row !important",
    margin: "15px 0!important",
  },

  ParaScoreInputs: {
    justifyContent: "center!important",
    color: "#ffffff",
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "12px",
    textAlign: "center",
  },
  rightBoxContent: {
    width: "80%",
  },
  ParaScoreSpanName: {
    display: "flex",
    flexDirection: "row",
  },
  ParaScoreSpanRank: {
    display: "flex",
    flexDirection: "column",
  },
  ParaScoreSpanScore: {
    display: "flex",
    flexDirection: "column",
  },
  ParaScoreSpanSmall: {
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
  },
  circle: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: "#00FF00",
    margin: "10px",
  },
};

const CaseCard = ({ classes, arcData, toggle = true, mainId }) => {
  const [load, setLoad] = useState(true);
  const articleRef = useRef([]);
  const [stateData, setStateData] = useState(arcData.data[0]);
  const [toggleData, setToggleData] = useState({
    age: 0,
    language_requirement_passed: 1,
  });
  const [saraSheetData, setSaraSheetData] = useState([]);
  const [yusefSheetData, setYusefSheetData] = useState([]);
  const [compareData, setCompareData] = useState([]);

  async function getData() {
    const saraRes = await axios.get(arcData.sara_sheet);
    const yusefRes = await axios.get(arcData.yusef_sheet);
    setSaraSheetData(tsvJSON(saraRes.data));
    setYusefSheetData(tsvJSON(yusefRes.data));
    let compData = [];
    tsvJSON(saraRes.data).map((item, i) => {
      if (item.is_default && item.is_default.includes("TRUE")) {
        compData.push(item);
      }
    });
    tsvJSON(yusefRes.data).map((item, i) => {
      if (item.is_default && item.is_default.includes("TRUE")) {
        compData.push(item);
      }
    });
    setCompareData(compData);
    setLoad(false);
  }

  const toggleChange = (e, check) => {
    if (e.target.checked) {
      setToggleData({ ...toggleData, [e.target.name]: 1 });
    } else {
      setToggleData({ ...toggleData, [e.target.name]: 0 });
    }
  };

  useEffect(() => {
    let saraArray = saraSheetData.find(
      (el) =>
        (toggleData.age === 0 ? el.age <= 35 : el.age >= 50) &&
        parseInt(el.language_requirement_passed) ===
        toggleData.language_requirement_passed
    );
    let yusefArray = yusefSheetData.find(
      (el) =>
        (toggleData.age === 0 ? el.age <= 35 : el.age >= 50) &&
        parseInt(el.language_requirement_passed) ===
        toggleData.language_requirement_passed
    );
    let newArray = [saraArray, yusefArray];
    setCompareData(newArray);
  }, [toggleData]);

  useEffect(() => {
    getData();
    const items = articleRef.current.children && Array.from(articleRef.current.children).map((item, i) => {
      return (item.children[0])
    }) || [];


    const detectIntersection = (entries) => {
      for (let e of entries) {
        let j = items.indexOf(e.target);
        if (e.isIntersecting) {
          setStateData(arcData.data[j]);
        }
      }
    };

    const options = {
      threshold: 0.25,
    };

    const observer = new IntersectionObserver(detectIntersection, options);
    items.forEach((i) => {
      observer.observe(i);
    });
    return () => {
      items.forEach((i) => {
        observer.unobserve(i);
      });
    }
  }, []);

  return (
    <section className={classes.main} id={mainId}>
      {(!load && (
        <>
          <article className={classes.left} ref={articleRef} >
            {arcData.data.map((row, r) => (
              <div key={r} className={classes.text}>
                {Parser(row.text)}
              </div>
            ))}
          </article>
          <figure className={classes.right}>
            <div className={classes.rightBox}>
              <div className={classes.rightBoxContent}>
                <h1>CASE PROFILE </h1>
                {(Object.keys(stateData).length &&
                  stateData.checks.length &&
                  stateData.checks.map((check, c) => (
                    <p
                      className={
                        check.animate
                          ? "showDataTrans boxRightContentPara colorChanger"
                          : "visible boxRightContentPara colorChanger"
                      }
                      key={c}
                    >
                      <span className={classes.flexBox}>
                        <span>{check.label}</span>
                        <span className="item"></span>
                        {toggle ? (
                          <span style={{ color: check.color }}>
                            {check.toggle ? (
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  defaultChecked={toggleData[check.name]}
                                  name={check.name}
                                  onChange={(e) => {
                                    toggleChange(e, check);
                                  }}
                                />
                                <span className="slider round"></span>
                              </label>
                            ) : (
                              (check.options &&
                                check.options.find(
                                  (e) =>
                                    parseInt(e.val) === parseInt(check.value)
                                ).label) ||
                              check.value
                            )}
                          </span>
                        ) : (
                          <span>
                            {(check.options &&
                              check.options.find(
                                (e) => parseInt(e.val) === parseInt(check.value)
                              ).label) ||
                              check.value}
                          </span>
                        )}
                      </span>
                    </p>
                  ))) || <></>}
              </div>
              {(compareData.length &&
                Object.keys(stateData).length &&
                stateData.compare &&
                stateData.compare.length && (
                  <>
                    <div className={classes.ParaScore + " boxRightContentPara"}>
                      {stateData.compare.map((user, u) => (
                        <p className={classes.ParaScoreSpan} key={u}>
                          <span className={classes.ParaScoreSpanName}>
                            <span>{user.name}</span>
                            <span
                              className={classes.circle}
                              style={{ background: user.color }}
                            ></span>
                          </span>
                          <span className={classes.ParaScoreSpanRank}>
                            <span>
                              {parseInt(
                                compareData[u].list_place
                              ).toLocaleString("en-US")}
                            </span>
                            <span className={classes.ParaScoreSpanSmall}>
                              risk ranking
                            </span>
                          </span>
                          <span className={classes.ParaScoreSpanScore}>
                            <span>
                              {parseFloat(compareData[u].score * 100).toFixed(
                                1
                              )}
                            </span>
                            <span className={classes.ParaScoreSpanSmall}>
                              Score
                            </span>
                          </span>
                        </p>
                      ))}
                    </div>
                    <div className={classes.slider}>
                      <RangeSlider rankValue={compareData[0].list_place} />
                      <p>Fraud investigation gauge</p>
                    </div>
                  </>
                )) || <></>}
            </div>
          </figure>{" "}
        </>
      )) || (
          <div className="loadBox">
            <div className="loader"></div>
          </div>
        )}
    </section>
  );
};

export default withStyles(styles)(CaseCard);
